import { Injectable } from '@angular/core';
import { Query, QueryEntity } from '@datorama/akita';
import { TaskTypeCategoryState, TaskTypeCategoryStore } from './taskTypeCategory.store';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeCategoryQuery extends QueryEntity<TaskTypeCategoryState> {
  constructor(protected store: TaskTypeCategoryStore) {
    super(store);
  }
}
